import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { TSqValidators } from '@tsq-web/forms';
import { Property } from '@tsq-web/property';
import { Phone, User } from '@tsq-web/users';

import { getEnvironment } from '../../../shared/environment';
import { CommunitiesEnvironments } from '../../../shared/environment/models/communities-environments.enum';
import { SignUpForm } from '../../models/sign-up-form.model';
import { PropertiesTypeaheadService } from '../../services/properties-typeahead.service';

@Component({
  selector: 'comm-neighbor-invite-register-sign-up-form',
  templateUrl: './sign-up-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpFormComponent {
  @Input() isLoading = false;
  @Input() isSigningUp = false;

  @Output() signUp = new EventEmitter<User>();

  protected readonly propertiesTypeaheadService = inject(PropertiesTypeaheadService);

  protected readonly form: FormGroup<SignUpForm> = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      TSqValidators.emptyOrHasCharDifferentThanWhitespace,
    ]),
    lastName: new FormControl('', [
      Validators.required,
      TSqValidators.emptyOrHasCharDifferentThanWhitespace,
    ]),
    email: new FormControl('', [Validators.required, TSqValidators.validEmail]),
    unit: new FormControl(null),
    phone: new FormControl(new Phone('')),
  });

  protected readonly defaultSelectedCountryCode =
    getEnvironment().env === CommunitiesEnvironments.BR_PROD ? 'BR' : 'US';
  protected readonly shimmersIterable = new Array(7);

  private _properties: Property[] = [];

  @Input() set properties(value: Property[]) {
    this._properties = value;

    if (!value?.length) {
      this.form.controls.unit.disable();
      return;
    }

    this.form.controls.unit.enable();
  }

  get properties(): Property[] {
    return this._properties;
  }

  @Input() set initialEmail(value: string) {
    this.form.controls.email.setValue(value);
  }

  submitForm(): void {
    const formValue = this.form.value;
    const user = new User();
    user.firstName = formValue.name?.trim();
    user.first_name = formValue.name?.trim();
    user.lastName = formValue.lastName?.trim();
    user.last_name = formValue.lastName?.trim();
    user.email = formValue.email?.trim();
    user.phones = [formValue.phone];
    user.properties = (formValue.unit?.value && [formValue.unit.value]) || [];

    this.signUp.emit(user);
  }
}
